import gql from "graphql-tag";

export default gql`
  mutation MaintenanceMode($status: Boolean!) {
    requestMaintenanceMode(status: $status)
  }
`;
